import React, { Component } from 'react';

import './Loading.css';
import logo from '../../assets/ccares-logo.png';

class Loading extends Component {
  state = {
    // The logo doesn't need to show on home screen PWAs because they have splash screen
    showLogo: !navigator.standalone,
  };

  render() {
    const { showLogo } = this.state;
    return (
      <div className="Loading">
        {
          showLogo
          && <img src={ logo } alt="" />
        }
      </div>
    );
  }
}

export default Loading;
